function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import { color } from 'styled-system';
import { shouldForwardProp } from '../../utils';
import { strictSpace } from '../../utils';
var fade = keyframes(["0%{opacity:0.2;}30%{opacity:1;}100%{opacity:0.2;}"]);
var Spinner = styled.div.withConfig({
  displayName: "Loader__Spinner",
  componentId: "sc-1oiky3s-0"
})(["position:relative;display:inline-block;"]);
var LoaderDot = styled.span.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Loader__LoaderDot",
  componentId: "sc-1oiky3s-1"
})(["display:inline-block;width:10px;height:10px;margin:0 4px;animation:", " 1.2s infinite;animation-fill-mode:both;opacity:0.2;border-radius:8px;", " &:nth-child(2){animation-delay:0.2s;}&:nth-child(3){animation-delay:0.4s;}"], fade, color);
var LoaderContainer = styled.div.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Loader__LoaderContainer",
  componentId: "sc-1oiky3s-2"
})(["", " ", ";"], strictSpace, function (_ref) {
  var center = _ref.center;
  return center && css(["text-align:center;"]);
});
/**
 * @component
 * Renders a spinner `div`. Useful for signaling loading state.
 */

var Loader = function Loader(props) {
  var editedProps = _objectSpread(_objectSpread({}, props), {}, {
    backgroundColor: props.color
  });

  return /*#__PURE__*/React.createElement(LoaderContainer, props, /*#__PURE__*/React.createElement(Spinner, null, /*#__PURE__*/React.createElement(LoaderDot, editedProps), /*#__PURE__*/React.createElement(LoaderDot, editedProps), /*#__PURE__*/React.createElement(LoaderDot, editedProps)));
};

Loader.propTypes = _objectSpread(_objectSpread({
  /** color can reference any of the [color variables](/#/Variables?id=colors) */
  color: PropTypes.string
}, color.propTypes), {}, {
  center: PropTypes.bool
});
Loader.defaultProps = {
  center: false,
  color: 'iconSelected'
};
export default Loader;